import React, { ReactNode } from "react"

import { Stack } from "@mui/material"

const Savings = ({ children }: { children: ReactNode }) => {
  return <Stack rowGap={2}>{children}</Stack>
}
export default Savings
